import { api } from "./client";
import type { PagedParams, SpringPage } from "./types";

/**
 * Contrato comum às telas de consulta do legado:
 * POST /{path}/Filtrar/Paginado/?page=&size=&sortField=&sortDirection=
 * com o filtro no corpo. `path` é relativo (ex. "instituicao/TipoArquivo"); o
 * axios instance `api` já tem BASE_URL_MS como baseURL e junta a barra sozinho.
 *
 * Nota: o legado, quando passa um `baseUrl` explícito terminado em "/" pro
 * PaginationService, acaba gerando uma barra dupla antes de "Filtrar" (ver
 * docs/migracao/diario.md, passo 1 — TipoArquivo). Não reproduzimos esse
 * acidente aqui; usamos a forma limpa. Se o gateway realmente exigir a barra
 * dupla por algum motivo, é o primeiro lugar a checar caso a paginação falhe
 * contra o backend real.
 */
export async function fetchPaged<T, F>(
  path: string,
  { page, size, sort, filtro }: PagedParams<F>,
  signal?: AbortSignal,
): Promise<SpringPage<T>> {
  const qs = new URLSearchParams({ page: String(page), size: String(size) });
  if (sort) {
    qs.set("sortField", sort.field);
    qs.set("sortDirection", sort.direction);
  }
  const { data } = await api.post<SpringPage<T>>(`${path}/Filtrar/Paginado/?${qs}`, filtro, { signal });
  return data;
}

/** Porte fiel de PaginationService.filtrarQuantidades(). */
export function pageSizeOptions(totalElements: number, currentSize: number): number[] {
  if (totalElements < 10) return [currentSize];
  const out: number[] = [];
  for (const q of [10, 25, 50, 100]) {
    if (q < totalElements) out.push(q);
    else break;
  }
  out.push(totalElements);
  return out;
}
